import axios, { AxiosResponse } from "axios";
import * as Sentry from "@sentry/react";

const speedKickApi =
  process.env.REACT_APP_SPEED_KICK_API_URL || "http://localhost:5000/api";

export interface User {
  emailAddress: string;
  firstName: string;
  lastName: string;
  marketingOptIn: boolean;
}

export interface Entry {
  eventId: string;
  questionId: string;
  userId: string;
  value: number;
}

const Api = {
  clearSession: async (): Promise<void> => {
    try {
      await axios.post(`${speedKickApi}/clear-session`, {}, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true
      });
      console.log('Session cleared successfully');
    } catch (error) {
      console.error('Failed to clear session:', error);
      // Don't throw - this is not critical
    }
  },
  saveEntry: async (entry: Entry): Promise<any | undefined> => {
    try {
      const entryUrl = `${speedKickApi}/events/${entry.eventId}/entries?version=2`;
      const response: AxiosResponse = await axios.post(entryUrl, {
        userId: entry.userId,
        entryValue: [{
        "key": "seconds",
        "type": "decimal-entry",
        "value": entry.value
      }],
        questionId: entry.questionId
      }, {
        headers: {
          "X-Api-Key": "Testing",
          "Content-Type": "application/json",
        },
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      console.log(error);
      Sentry.captureException(error);
      throw new Error("Unable to create entry. Please try again.");
    }
  },
  newUser: async (userDetails: User): Promise<{userId: string} | undefined> => {
    try {
      const response: AxiosResponse = await axios.post(`${speedKickApi}/users`, userDetails, {
        headers: {
          "X-Api-Key": "Testing",
          "Content-Type": "application/json",
        },
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      //Sentry
      return undefined;
    }
  },
};

export default Api;
